<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import Button from 'next/button/Button.vue';
import CreateSamlProviderForm from './CreateSamlProviderForm.vue';

const emit = defineEmits(['close']);

const { t } = useI18n();
const store = useStore();

const uiFlags = useMapGetter('wgptSamlProviders/getUIFlags');
const createSamlProviderFormRef = ref(null);

const handleSubmit = async () => {
  if (!createSamlProviderFormRef.value) return;
  const { v$, state } = createSamlProviderFormRef.value;

  try {
    const isValid = await v$.$validate();
    if (!isValid) return;

    const data = {
      display_name: state.display_name,
    };
    if (state.useUrl) {
      data.sp_metadata_url = state.sp_metadata_url;
    } else {
      data.sp_metadata = state.sp_metadata;
    }
    await store.dispatch('wgptSamlProviders/create', data);

    useAlert(t('WGPT_SAML.PROVIDERS.CREATE.API.SUCCESS_MESSAGE'));
    emit('close');
  } catch (error) {
    const errorMessage =
      error.message || t('WGPT_SAML.PROVIDERS.CREATE.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleCancel = () => {
  emit('close');
};
</script>

<template>
  <div class="w-[400px] p-6 flex flex-col gap-6">
    <h3 class="text-base font-medium text-slate-900 dark:text-slate-50">
      {{ t(`WGPT_SAML.PROVIDERS.CREATE.TITLE`) }}
    </h3>
    <CreateSamlProviderForm
      ref="createSamlProviderFormRef"
      @submit="handleSubmit"
    />
    <div class="flex items-center justify-between w-full gap-3">
      <Button
        variant="faded"
        color="slate"
        :label="t('WGPT_SAML.PROVIDERS.CREATE.FORM.CANCEL')"
        class="w-full bg-n-alpha-2 n-blue-text hover:bg-n-alpha-3"
        @click="handleCancel"
      />
      <Button
        :label="t(`WGPT_SAML.PROVIDERS.CREATE.FORM.CREATE`)"
        class="w-full"
        :disabled="uiFlags.isCreating"
        :is-loading="uiFlags.isCreating"
        @click="handleSubmit"
      />
    </div>
  </div>
</template>
